import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const checkApiKey = async () => {
  try {
    const response = await axios.get(`${API_URL}/check-apikey`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const setApiKey = async (apiKey) => {
  try {
    const response = await axios.post(`${API_URL}/set-apikey`, { apiKey });
    return response.data;
  } catch (error) {
    console.error('Error setting API key:', error);
    throw error;
  }
};

export const generateReview = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/generate-review`, {
      abstract: data.abstract,
      papers: data.papers,
      parameters: data.parameters
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const regenerateWithPlan = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/regenerate-with-plan`, {
      abstract: data.abstract,
      plan: data.plan,
      papers: data.papers,
      parameters: data.parameters
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateHighLevelPlan = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/generate-high-level-plan`, {
      abstract: data.abstract,
      papers: data.papers,
      parameters: data.parameters,
      socketId: data.socketId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateReviewFromPlan = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/generate-review-from-plan`, {
      abstract: data.abstract,
      highLevelPlan: data.highLevelPlan,
      papers: data.papers,
      parameters: data.parameters,
      socketId: data.socketId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRankingReasoning = async (socketId) => {
  try {
    const response = await axios.get(`${API_URL}/get-ranking-reasoning`, {
      params: { socketId }
    });
    return response.data;
  } catch (error) {
    // If not found, just return false for dataAvailable instead of throwing
    if (error.response && error.response.status === 404) {
      return { dataAvailable: false };
    }
    throw error;
  }
};

export const startStreamingHighLevelPlan = async (data) => {
  try {
    // Make the initial POST request to start the streaming process
    const response = await fetch(`${API_URL}/sse/generate-high-level-plan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        abstract: data.abstract,
        papers: data.papers,
        parameters: data.parameters
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return the response object to be used with an EventSource
    return response;
  } catch (error) {
    throw error;
  }
};

export const startStreamingReviewFromPlan = async (data) => {
  try {
    // Make the initial POST request to start the streaming process
    const response = await fetch(`${API_URL}/sse/generate-review-from-plan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        abstract: data.abstract,
        highLevelPlan: data.highLevelPlan,
        papers: data.papers,
        parameters: data.parameters
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return the response object to be used with an EventSource
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStreamingHighLevelPlanUrl = () => {
  return `${API_URL}/sse/generate-high-level-plan`;
};

export const getStreamingReviewFromPlanUrl = () => {
  return `${API_URL}/sse/generate-review-from-plan`;
}; 